<div *ngFor="let category of channelCategoryList" class="category-list" data-cy="channels-side-menu-category-list-item">
    <div class="category-wrapper">
        <div class="text" data-cy="channels-side-menu-category-index">
            {{ category.rowId }}
        </div>
        <div class="text" data-cy="channels-side-menu-category-name">
            {{ category.category }}
        </div>
        <div class="sub-title" data-cy="channels-side-menu-category-no-of-channel-groups">
            {{
                'channel.more-options.sub-title.' + (getGroupsCount(category.id) === 1 ? 'one' : 'other')
                    | translate: { groups: getGroupsCount(category.id) }
            }}
        </div>
    </div>

    <mat-icon
        svgIcon="more-options"
        class="icon"
        data-cy="channels-side-menu-category-kebab-icon"
        (click)="openMore($event, category)"></mat-icon>
</div>
